<template>
  <el-dialog v-dialogDrag :title="'人员姓名：' + username" :visible.sync="panel" :before-close="closeDialog"
    :close-on-click-modal="false" :close-on-press-escape="false" height="40%" class="workDialog">
    <el-table :data="detaildata" style="width: 100%;min-height:500px" height="100%" border>
      <el-table-column prop="itemName" label="项目" width="150"></el-table-column>
      <el-table-column prop="specName" label="专业"></el-table-column>
      <el-table-column prop="roleName" label="角色"></el-table-column>
      <el-table-column prop="openTime" label="任务时间" width="150"></el-table-column>
      <el-table-column prop="workTime" label="任务时长（小时）"></el-table-column>
      <el-table-column prop="commitTime" label="提交时间" width="150"></el-table-column>
    </el-table>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      panel: false,
      username: "",
      detaildata: []
    };
  },
  methods: {
    closeDialog() {
      this.panel = false;
    },
    showpanel(bool, val, data) {
      this.panel = bool;
      this.username = val;
      this.detaildata = data;
    }
  }
};
</script>
<style lang="scss" scope="scoped">
.workDialog{
  .el-dialog__body {
    height: calc(100% - 52px) !important;
  }
}
</style>
